export const products = [
	{
		id: 1,
		name: 'iPhone 14 Pro',
		category: 'Smartphones',
		brand: 'Apple',
		price: {
			shopA: 999,
			shopB: 1050,
			shopC: 970,
			shopD: 1020,
			shopE: 990,
			shopF: 1010,
			shopG: 985,
			shopH: 995,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.8,
		description: 'Latest iPhone with A16 chip and ProMotion display.',
		specifications: [
			'6.1-inch display',
			'128GB storage',
			'Triple-camera system',
		],
		priceHistory: [
			{ date: '2023-01-01', price: 1099 },
			{ date: '2023-03-01', price: 1050 },
			{ date: '2023-06-01', price: 999 },
		],
		reviews: [
			{ user: 'John', text: 'Great phone!', rating: 5 },
			{ user: 'Jane', text: 'Battery life could be better.', rating: 4 },
		],
		image:
			'https://mtscdn.ru/upload/iblock/404/iphone_14_pro_finish_select_202209_6_1inch_spaceblack_PhotoRoom.png/resize/200x200/',
	},
	{
		id: 2,
		name: 'Samsung Galaxy S23',
		category: 'Smartphones',
		brand: 'Samsung',
		price: {
			shopA: 899,
			shopB: 920,
			shopC: 870,
			shopD: 910,
			shopE: 880,
			shopF: 900,
			shopG: 860,
			shopH: 870,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.7,
		description: 'Flagship Samsung smartphone with Snapdragon 8 Gen 2.',
		specifications: ['6.1-inch display', '128GB storage', 'Quad-camera system'],
		priceHistory: [
			{ date: '2023-01-01', price: 999 },
			{ date: '2023-03-01', price: 950 },
			{ date: '2023-06-01', price: 899 },
		],

		reviews: [],
		image:
			'https://mtscdn.ru/upload/iblock/d39/SMS_PC_S23_PHANTOM_BLACK_1000_01.png',
	},
	{
		id: 3,
		name: 'Google Pixel 7',
		category: 'Smartphones',
		brand: 'Google',
		price: {
			shopA: 799,
			shopB: 820,
			shopC: 780,
			shopD: 800,
			shopE: 770,
			shopF: 790,
			shopG: 760,
			shopH: 780,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.6,
		description: "Google's flagship phone with Tensor G2 chip.",
		specifications: ['6.3-inch display', '128GB storage', 'Dual-camera system'],
		priceHistory: [
			{ date: '2023-01-01', price: 899 },
			{ date: '2023-03-01', price: 850 },
			{ date: '2023-06-01', price: 799 },
		],
		reviews: [{ user: 'Alice', text: 'Smooth Android experience.', rating: 5 }],
		image:
			'https://mtscdn.ru/upload/iblock/04d/zagruzka-_67_-_1_.png/resize/208x208/',
	},
	{
		id: 4,
		name: 'MacBook Air M2',
		category: 'Laptops',
		brand: 'Apple',
		price: {
			shopA: 1199,
			shopB: 1250,
			shopC: 1150,
			shopD: 1200,
			shopE: 1180,
			shopF: 1220,
			shopG: 1170,
			shopH: 1190,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.9,
		description: 'Ultra-thin laptop with Apple M2 chip.',
		specifications: ['13.6-inch Retina display', '256GB SSD', '8GB RAM'],
		priceHistory: [
			{ date: '2023-01-01', price: 1299 },
			{ date: '2023-03-01', price: 1250 },
			{ date: '2023-06-01', price: 1199 },
		],
		reviews: [{ user: 'Michael', text: 'Amazing battery life!', rating: 5 }],
		image:
			'https://mtscdn.ru/upload/iblock/88d/Bez-nazvaniya-_5_.png/resize/208x208/',
	},

	{
		id: 5,
		name: 'iPad Pro 12.9',
		category: 'Tablets',
		brand: 'Apple',
		price: {
			shopA: 1099,
			shopB: 1150,
			shopC: 1070,
			shopD: 1100,
			shopE: 1080,
			shopF: 1120,
			shopG: 1090,
			shopH: 1110,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.8,
		description: 'High-performance tablet with M2 chip.',
		specifications: [
			'12.9-inch display',
			'128GB storage',
			'Apple Pencil support',
		],
		reviews: [],
		image:
			'https://best-magazin.com/image/cache/catalog/Apple/iPad/Pro/12.9%20%282022%29/image%201-800x800.png',
	},
	{
		id: 6,
		name: 'Xiaomi 13 Ultra',
		category: 'Smartphones',
		brand: 'Xiaomi',
		price: {
			shopA: 799,
			shopB: 820,
			shopC: 780,
			shopD: 800,
			shopE: 770,
			shopF: 790,
			shopG: 760,
			shopH: 780,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.5,
		description: 'Флагман с камерой Leica и Snapdragon 8 Gen 2',
		specifications: ['6.7-inch AMOLED', '256GB storage', '120Hz refresh rate'],
		reviews: [],
		image: 'https://mtscdn.ru/upload/iblock/6c0/Black_1.png/resize/208x208/',
	},
	{
		id: 7,
		name: 'OnePlus 11',
		category: 'Smartphones',
		brand: 'OnePlus',
		price: {
			shopA: 699,
			shopB: 720,
			shopC: 670,
			shopD: 700,
			shopE: 680,
			shopF: 710,
			shopG: 660,
			shopH: 690,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.6,
		description: 'Флагман с Hasselblad камерой и быстрой зарядкой',
		specifications: ['6.7-inch QHD+', '12GB RAM', '100W charging'],
		reviews: [],
		image:
			'https://oneplus.com.ru/uploads/store/product/b4d8f98025730d7427695bb8b461505a.png',
	},
	{
		id: 8,
		name: 'Dell XPS 13',
		category: 'Laptops',
		brand: 'Dell',
		price: {
			shopA: 999,
			shopB: 1050,
			shopC: 970,
			shopD: 1000,
			shopE: 980,
			shopF: 1020,
			shopG: 990,
			shopH: 1010,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.8,
		description: 'Ultra-thin and lightweight laptop with InfinityEdge display.',
		specifications: ['13.4-inch FHD+', '512GB SSD', '16GB RAM'],
		reviews: [],
		image:
			'https://mtscdn.ru/upload/iblock/fbe/Bez-nazvaniya-_3_.png/resize/208x208/',
	},
	{
		id: 9,
		name: 'HP Spectre x360',
		category: 'Laptops',
		brand: 'HP',
		price: {
			shopA: 1299,
			shopB: 1350,
			shopC: 1250,
			shopD: 1300,
			shopE: 1280,
			shopF: 1320,
			shopG: 1270,
			shopH: 1290,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.7,
		description: 'Convertible laptop with OLED display.',
		specifications: ['14-inch 4K OLED', '1TB SSD', '16GB RAM'],
		reviews: [],
		image: 'https://mtscdn.ru/upload/iblock/666/1.png/resize/208x208/',
	},
	{
		id: 10,
		name: 'Sony WH-1000XM5',
		category: 'Headphones',
		brand: 'Sony',
		price: {
			shopA: 349,
			shopB: 360,
			shopC: 330,
			shopD: 350,
			shopE: 340,
			shopF: 360,
			shopG: 330,
			shopH: 350,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.9,
		description: 'Industry-leading noise cancellation.',
		specifications: ['Bluetooth 5.2', '30-hour battery life', 'Touch controls'],
		reviews: [],
		image:
			'https://doctorhead.ru/upload/resize_cache/webp/iblock/969/auvd09sdtk24x7o8wb0zh0h49p2xo0t1/sony_wh1000xm5_black.webp',
	},
	{
		id: 11,
		name: 'Apple AirPods Max',
		category: 'Headphones',
		brand: 'Apple',
		price: {
			shopA: 549,
			shopB: 570,
			shopC: 520,
			shopD: 550,
			shopE: 540,
			shopF: 560,
			shopG: 530,
			shopH: 550,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.8,
		description: 'Premium over-ear headphones with spatial audio.',
		specifications: [
			'Active noise cancellation',
			'20-hour battery life',
			'Memory foam ear cushions',
		],
		reviews: [],
		image: 'https://i-store.net/_sh/54/5445.jpg',
	},
	{
		id: 12,
		name: 'Samsung Galaxy Tab S9',
		category: 'Tablets',
		brand: 'Samsung',
		price: {
			shopA: 699,
			shopB: 720,
			shopC: 680,
			shopD: 700,
			shopE: 690,
			shopF: 710,
			shopG: 670,
			shopH: 690,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.7,
		description: 'Powerful tablet with AMOLED display.',
		specifications: ['11-inch AMOLED', '128GB storage', 'S Pen support'],
		reviews: [],
		image:
			'https://melitopol.allohastore.ru/image/cache/catalog/samsung/tab%20s9/009-galaxy-tabs9-graphite-combo-800x800.jpg',
	},
	{
		id: 13,
		name: 'Microsoft Surface Pro 9',
		category: 'Tablets',
		brand: 'Microsoft',
		price: {
			shopA: 999,
			shopB: 1050,
			shopC: 970,
			shopD: 1000,
			shopE: 980,
			shopF: 1020,
			shopG: 990,
			shopH: 1010,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.8,
		description: 'Versatile 2-in-1 tablet with Windows 11.',
		specifications: ['13-inch PixelSense', '256GB SSD', '8GB RAM'],
		reviews: [],
		image: 'https://orderit.ru/data/big/surface_pro_9_sapphire_1.jpeg',
	},

	{
		id: 14,
		name: 'Bose QuietComfort 45',
		category: 'Headphones',
		brand: 'Bose',
		price: {
			shopA: 279,
			shopB: 290,
			shopC: 260,
			shopD: 280,
			shopE: 270,
			shopF: 290,
			shopG: 260,
			shopH: 280,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.7,
		description:
			'Comfortable noise-cancelling headphones for long listening sessions.',
		specifications: [
			'Bluetooth 5.1',
			'24-hour battery life',
			'Adjustable noise cancellation',
		],
		reviews: [],
		image:
			'https://bosestore.ru/upload/iblock/b9e/az0tpimd7xchwytu8gx06wasvhghvpxv/bose_quietcomfort_45_black_01.jpg',
	},
	{
		id: 15,
		name: 'Jabra Elite 85t',
		category: 'Headphones',
		brand: 'Jabra',
		price: {
			shopA: 199,
			shopB: 210,
			shopC: 180,
			shopD: 200,
			shopE: 190,
			shopF: 200,
			shopG: 180,
			shopH: 190,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.6,
		description: 'True wireless earbuds with active noise cancellation.',
		specifications: [
			'Bluetooth 5.2',
			'5.5-hour battery life (earbuds)',
			'Wireless charging case',
		],
		reviews: [],
		image:
			'https://doctorhead.ru/upload/resize_cache/webp/iblock/3b4/Jabra_Elite_85t_new_500.webp',
	},
	{
		id: 16,
		name: 'Sennheiser Momentum 4 Wireless',
		category: 'Headphones',
		brand: 'Sennheiser',
		price: {
			shopA: 399,
			shopB: 410,
			shopC: 380,
			shopD: 400,
			shopE: 390,
			shopF: 400,
			shopG: 380,
			shopH: 390,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.8,
		description: 'Premium sound quality with long battery life.',
		specifications: [
			'Bluetooth 5.2',
			'60-hour battery life',
			'Active noise cancellation',
		],
		reviews: [],
		image:
			'https://doctorhead.ru/upload/resize_cache/webp/iblock/251/6qyawz1htalk51hn4lpadadrjug1630z/sennheiser_momentum4_black_00.webp',
	},

	{
		id: 17,
		name: 'Lenovo ThinkPad X1 Carbon Gen 10',
		category: 'Laptops',
		brand: 'Lenovo',
		price: {
			shopA: 1399,
			shopB: 1450,
			shopC: 1350,
			shopD: 1400,
			shopE: 1380,
			shopF: 1420,
			shopG: 1370,
			shopH: 1390,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.8,
		description: 'Business-class laptop with durable design.',
		specifications: ['14-inch FHD+', '1TB SSD', '16GB RAM'],
		reviews: [],
		image: 'https://mtscdn.ru/upload/iblock/718/0209_1281.png/resize/208x208/',
	},
	{
		id: 18,
		name: 'Asus ROG Zephyrus G14',
		category: 'Laptops',
		brand: 'Asus',
		price: {
			shopA: 1499,
			shopB: 1550,
			shopC: 1450,
			shopD: 1500,
			shopE: 1480,
			shopF: 1520,
			shopG: 1470,
			shopH: 1490,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.7,
		description: 'Powerful gaming laptop with AMD Ryzen processor.',
		specifications: ['14-inch QHD', '1TB SSD', '32GB RAM'],
		reviews: [],
		image:
			'https://dlcdnwebimgs.asus.com/gain/8D12A135-FBA7-4C6F-BB9D-A654F4398FFD/w1000/h732',
	},
	{
		id: 19,
		name: 'Razer Blade 15',
		category: 'Laptops',
		brand: 'Razer',
		price: {
			shopA: 1799,
			shopB: 1850,
			shopC: 1750,
			shopD: 1800,
			shopE: 1780,
			shopF: 1820,
			shopG: 1770,
			shopH: 1790,
		},
		shopLinks: {
			shopA: 'https://example.com/shopA',
			shopB: 'https://example.com/shopB',
			shopC: 'https://example.com/shopC',
			shopD: 'https://example.com/shopD',
			shopE: 'https://example.com/shopE',
			shopF: 'https://example.com/shopF',
			shopG: 'https://example.com/shopG',
			shopH: 'https://example.com/shopH',
		},
		rating: 4.9,
		description: 'High-performance gaming laptop with sleek design.',
		specifications: ['15.6-inch 4K OLED', '1TB SSD', '32GB RAM'],
		reviews: [],
		image:
			'https://manuals.plus/wp-content/uploads/2021/03/razer-blade-15-advanced-4.png',
	},
]

export const categories = [
	{
		id: 1,
		name: 'Smartphones',
		image:
			'https://media.istockphoto.com/id/1405838999/ru/%D1%84%D0%BE%D1%82%D0%BE/%D1%81%D0%BC%D0%B0%D1%80%D1%82%D1%84%D0%BE%D0%BD-%D0%BF%D0%BE%D1%85%D0%BE%D0%B6-%D0%BD%D0%B0-iphone-13-%D1%81-%D0%BF%D1%83%D1%81%D1%82%D1%8B%D0%BC-%D0%B1%D0%B5%D0%BB%D1%8B%D0%BC-%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%BE%D0%BC-%D0%B4%D0%BB%D1%8F-%D0%B8%D0%BD%D1%84%D0%BE%D0%B3%D1%80%D0%B0%D1%84%D0%B8%D0%BA%D0%B8-global-business-marketing.jpg?s=612x612&w=0&k=20&c=yUtok-E-RbvsQ1jgVzCRzfx534cDvj75GI6iR3yh4YE=',
	},
	{
		id: 2,
		name: 'Laptops',
		image:
			'https://i5.storeland.net/3/271/202708137/075a3e/noutbuk-microsoft-surface-laptop-6-15-intel-core-ultra-5-135h-16gb-256gb-black-metall-windows-11-pro.png',
	},
	{
		id: 3,
		name: 'Tablets',
		image:
			'https://cdn2.vectorstock.com/i/1000x1000/72/91/simple-tablet-pc-template-vector-24427291.jpg',
	},
	{
		id: 4,
		name: 'Headphones',
		image:
			'https://image.made-in-china.com/2f0j00eupqanctOlkG/New-Simple-Design-Wireless-Headsets-Bluetooth-Headphone-with-Touch-Control.webp',
	},
	{
		id: 5,
		name: 'Gaming',
		image:
			'https://distritech.com/cdn/shop/files/SON-1.000039655E9-W_678x.png?v=1731964460',
	},
	{
		id: 6,
		name: 'Cameras',
		image:
			'https://i1.adis.ws/i/canon/eos-r100-frt_range_82fb27b9ade0445f8d500916679ef0d6?$prod-grid-1by1-jpg$',
	},
	{
		id: 7,
		name: 'Smartwatches',
		image:
			'https://image.made-in-china.com/202f0j00NvRlYOLJLUbZ/2021-Latest-Model-Top-Sale-Smartwatch-Ak88-Smartwatches.webp',
	},
]
